<template>
  <v-text-field
    v-model="inputDate"
    :label="label"
    placeholder="dd/mm/yyyy"
    :disabled="isDisabled"
    :error-messages="errorMessage"
    variant="outlined"
    density="compact"
    color="fieldOutlineColor"
    @keyup="addSlashes($event)"
    @blur="validate()"
  />
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import moment from "moment";

const props = withDefaults(
  defineProps<{
    label?: string;
    value: null | object | string;
    error?: string;
    isReportMode?: boolean;
    isDisabled?: boolean;
  }>(),
  {
    label: "",
    error: "",
    isReportMode: false,
    isDisabled: false,
  }
);

const emit = defineEmits<{
  (e: "updateEvent", newDate: string): void;
  (e: "valid", isValid: boolean): void;
}>();

const inputDate = ref((props.value as unknown as string) ?? "");
const hasError = ref(false);

const errorMessage = computed(() => (hasError.value ? "Invalid date" : ""));

function isValid() {
  const dateFormat: string = "DD/MM/YYYY";

  if (inputDate.value?.length == dateFormat.length) {
    const checkDate = moment(inputDate.value, dateFormat, true).format();
    return checkDate != "Invalid date";
  }
  if (inputDate.value?.length == 0) {
    return true;
  }
  return false;
}

function addSlashes(event: any) {
  // Insert slashes automatically when date is being typed
  if (
    (inputDate.value?.length == 2 || inputDate.value?.length == 5) &&
    event.key != "Backspace"
  ) {
    inputDate.value += "/";
  }
}

function validate() {
  hasError.value = !isValid();
  const inputLength = inputDate.value?.length ?? 0;
  if (inputLength > 0 && hasError.value) {
    emitValid(false);
  } else {
    emitInputDate();
    emitValid(true);
  }
}

function emitInputDate(): void {
  emit("updateEvent", inputDate.value);
}

function emitValid(isValid: boolean): void {
  emit("valid", isValid);
}
</script>
